import { createAsyncThunk } from "@reduxjs/toolkit";
import { customerPortal } from "@vilocnv/allsetra-core";
import { deleteGeozone } from "domain/geozones/api/delete-geozone";

type DeleteGeozoneRequestDto = customerPortal.geozones.DeleteGeozoneRequestDto;

export const deleteGeozoneAction = createAsyncThunk(
  "geozones/deleteGeozoneAction",
  async ({ accountId, accountGeoFenceId }: DeleteGeozoneRequestDto) => {
    try {
      return await deleteGeozone({ accountId, accountGeoFenceId });
    } catch (e: any) {
      console.error(e);
      throw new Error(e);
    }
  }
);
